import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface PagoFiltros {
  nombre?: string;
  correo?: string;
  status?: string;
  metodo?: string;
  desde?: string;
  hasta?: string;
  page?: number;
  size?: number;
}

@Injectable({ providedIn: 'root' })
export class AdminSuscripcionesService {
  private base = `${environment.baseApi}/privado/admin/suscripciones`;

  constructor(private http: HttpClient) {}

  stats(): Observable<any> {
    return this.http.get(`${this.base}/stats`);
  }

  pagos(filtros: PagoFiltros = {}): Observable<any> {
    let params = new HttpParams();
    Object.entries(filtros).forEach(([k, v]) => {
      if (v !== null && v !== undefined && v !== '') {
        params = params.set(k, v.toString());
      }
    });
    return this.http.get(`${this.base}/pagos`, { params });
  }

  buscarCandidatos(q: string): Observable<any> {
    return this.http.get(`${this.base}/candidatos/buscar`, {
      params: new HttpParams().set('q', q)
    });
  }

  registrarPagoManual(form: FormData): Observable<any> {
    return this.http.post(`${this.base}/pagos`, form);
  }
}
